'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../utils/underscore');

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UIPopoverHeader = require('./UIPopoverHeader');

var _UIPopoverHeader2 = _interopRequireDefault(_UIPopoverHeader);

var _UIPopoverBody = require('./UIPopoverBody');

var _UIPopoverBody2 = _interopRequireDefault(_UIPopoverBody);

var _UIPopoverFooter = require('./UIPopoverFooter');

var _UIPopoverFooter2 = _interopRequireDefault(_UIPopoverFooter);

var _UIPopoverArrow = require('./UIPopoverArrow');

var _UIPopoverArrow2 = _interopRequireDefault(_UIPopoverArrow);

var _PlacementConstants = require('./PlacementConstants');

var _times = require('HubStyleTokens/times');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POPOVER_TRANSITION_TIMEOUT = parseInt(_times.POPOVER_TRANSITION_TIMING, 10);

var POSITION_RELATIVE = {
  position: 'relative'
};

var USE_CLASSES = {
  'default': 'uiPopover--default private-popover--default',
  'longform': 'private-tooltip--longform',
  'shepherd': 'private-popover--shepherd',
  'tooltip': 'private-popover--tooltip',
  'unstyled': 'private-popover--unstyled'
};

var UIPopoverContent = _react2.default.createClass({
  displayName: 'UIPopoverContent',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    animateOnMount: _react.PropTypes.bool.isRequired,
    animateOnToggle: _react.PropTypes.bool.isRequired,
    hasRendered: _react.PropTypes.bool.isRequired,
    arrowColor: _react.PropTypes.string,
    arrowSize: _react.PropTypes.oneOf((0, _underscore.keys)(_UIPopoverArrow2.default.ARROW_SIZES)),
    className: _react.PropTypes.string,
    content: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.shape({
      header: _react.PropTypes.node,
      body: _react.PropTypes.node,
      footer: _react.PropTypes.node
    })]).isRequired,
    id: _react.PropTypes.string,
    onOpenChange: _react.PropTypes.func,
    open: _react.PropTypes.bool,
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
    style: _react.PropTypes.object,
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)),
    width: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      animateOnMount: false,
      animateOnToggle: true,
      hasRendered: false,
      arrowSize: 'medium',
      open: false,
      placement: 'top',
      use: 'default'
    };
  },
  getArrowParams: function getArrowParams() {
    return _UIPopoverArrow2.default.ARROW_SIZES[this.props.arrowSize];
  },
  getPopoverClassName: function getPopoverClassName() {
    var _props = this.props,
        className = _props.className,
        use = _props.use;

    return (0, _reactUtils.classNames)(className, USE_CLASSES[use], 'private-popover', 'uiPopover');
  },
  renderStructuredContent: function renderStructuredContent() {
    var content = this.props.content;
    var header = content.header,
        body = content.body,
        footer = content.footer;

    var headerArrow = this.renderHeaderArrow();
    var bodyArrow = this.renderBodyArrow();
    var footerArrow = this.renderFooterArrow();
    return [header ? _react2.default.createElement(
      _UIPopoverHeader2.default,
      { key: 'header' },
      header,
      headerArrow
    ) : headerArrow, body ? _react2.default.createElement(
      _UIPopoverBody2.default,
      { key: 'body' },
      body,
      bodyArrow
    ) : bodyArrow, footer ? _react2.default.createElement(
      _UIPopoverFooter2.default,
      { key: 'footer' },
      footer,
      footerArrow
    ) : footerArrow];
  },
  renderArrow: function renderArrow() {
    var arrowParams = this.getArrowParams();
    var _props2 = this.props,
        arrowColor = _props2.arrowColor,
        placement = _props2.placement;

    return _react2.default.createElement(_UIPopoverArrow2.default, {
      color: arrowColor,
      inset: arrowParams.inset,
      key: 'arrow',
      placement: placement,
      width: arrowParams.width
    });
  },
  renderSimpleContent: function renderSimpleContent() {
    var content = this.props.content;

    return _react2.default.createElement(
      'div',
      { key: 'content' },
      content
    );
  },
  renderHeaderArrow: function renderHeaderArrow() {
    // Render the arrow in the header if we're on the bottom side or edge
    return this.props.placement.match(/bottom/) ? this.renderArrow() : null;
  },
  renderBodyArrow: function renderBodyArrow() {
    // Render the arrow in the body if we're not placed on the top or bottom
    return this.props.placement.match(/bottom|top/) ? null : this.renderArrow();
  },
  renderFooterArrow: function renderFooterArrow() {
    // Render the arrow in the footer if we're on the top side or edge
    return this.props.placement.match(/top/) ? this.renderArrow() : null;
  },
  renderPopoverContent: function renderPopoverContent() {
    var _props3 = this.props,
        content = _props3.content,
        id = _props3.id,
        open = _props3.open,
        width = _props3.width,
        style = _props3.style;

    var widthStyle = width ? { maxWidth: width, width: width } : {};

    if (open) {
      return _react2.default.createElement(
        'div',
        {
          className: this.getPopoverClassName(),
          id: id,
          style: _extends({}, POSITION_RELATIVE, widthStyle, style)
        },
        _react2.default.isValidElement(content) ? [this.renderArrow(), this.renderSimpleContent()] : this.renderStructuredContent()
      );
    }

    return null;
  },
  render: function render() {
    var _props4 = this.props,
        animateOnMount = _props4.animateOnMount,
        animateOnToggle = _props4.animateOnToggle,
        hasRendered = _props4.hasRendered;


    return _react2.default.createElement(
      _reactAddonsCssTransitionGroup2.default,
      {
        transitionAppear: animateOnMount && !hasRendered || animateOnToggle && hasRendered,
        transitionAppearTimeout: POPOVER_TRANSITION_TIMEOUT,
        transitionEnter: animateOnToggle,
        transitionEnterTimeout: POPOVER_TRANSITION_TIMEOUT,
        transitionLeave: animateOnToggle,
        transitionLeaveTimeout: POPOVER_TRANSITION_TIMEOUT,
        transitionName: 'uiPopover'
      },
      this.renderPopoverContent()
    );
  }
});

exports.default = UIPopoverContent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/tooltip/UIPopoverContent.js
// module id = 259
// module chunks = 0 1